import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import ElementUI from "element-ui"
import axios from "./api/http"
import api from "./api/api"
import "element-ui/lib/theme-chalk/index.css"

Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app")
